import React, {Component, Fragment} from 'react';
import IMisFetchHost from "../../../../models/hosted-salamander/IMisFetchHost";
import {CommandBarButton, MessageBar, MessageBarButton, MessageBarType} from "office-ui-fabric-react";
import IMisFetchRun from '../../../../models/hosted-salamander/IMisFetchRun';
import School from "../../../../models/School";
import IHostedSalamanderConfig from "../../../../models/hosted-salamander/IHostedSalamanderConfig";
import SchoolPageTitle from '../../../SchoolPageTitle';
import AdminSchoolMenu from '../../../AdminSchoolMenu';
import {MisDataServiceTypes} from "../../../../models/SchoolMailroomConfigDto";
import {ICDBPageProps} from "../../../../utils/ICDBPageProps";
import MisFetchAvailableDataServiceDropdown from "../../../mis-fetch/MisFetchAvailableDataServiceDropdown";
import {Link} from "react-router-dom";
import MisFetchHostTable from "../../../mis-fetch/MisFetchHostTable";
import MisFetchRunTable from "../../../mis-fetch/MisFetchRunTable";


interface MisFetchSchoolPageProps extends ICDBPageProps
{
    tenantId:string;
    schoolCode:string;
    dataServiceType: MisDataServiceTypes;
}

interface MisFetchSchoolPageState {
    school?: School;
    hostedConfig?: IHostedSalamanderConfig | null;
    host?: IMisFetchHost | null;
    hostRuns?: IMisFetchRun[];

    currentHostRun?: IMisFetchRun;
}

export default class MisFetchSchoolPage extends Component<MisFetchSchoolPageProps, MisFetchSchoolPageState> {
    static displayName = MisFetchSchoolPage.name;

    constructor(props: MisFetchSchoolPageProps) {
        super(props);

        this.state = {
            host: undefined
        }
    }

    async componentDidMount() {
        await this.loadSchool();
        await this.loadHostedConfig();
        await this.loadHostAndRuns();
    }

    async componentDidUpdate(prevProps: Readonly<MisFetchSchoolPageProps>, prevState: any): Promise<void> {
        
        if(this.props.tenantId !== prevProps.tenantId || this.props.schoolCode != prevProps.schoolCode || this.props.dataServiceType !== prevProps.dataServiceType)
        {
            await this.loadSchool();
            await this.loadHostedConfig();
            await this.loadHostAndRuns();
        }
    }
    
    private loadSchool = async () => {
        this.setState({
            school: undefined
        });
        
        const school = await this.props.apiService.getSchoolAdmin(this.props.tenantId,this.props.schoolCode);
        
        this.setState({
            school: school
        });
    }
    
    private loadHostedConfig = async () => {
        
        if(this.props.dataServiceType !== MisDataServiceTypes.SalamanderHosted)
        {
            return;
        }
        
        this.setState({
            hostedConfig: undefined
        });

        const hostedConfig = await this.props.apiService.getHostedSalamanderConfig(this.props.tenantId,this.props.schoolCode);

        this.setState({
            hostedConfig: hostedConfig
        });
    }
    
    private loadHostAndRuns = async () => {

        this.setState({
            host: undefined,
            hostRuns: undefined
        });


        const host = await this.props.apiService.getMisFetchHost(this.props.tenantId,this.props.schoolCode,this.props.dataServiceType)
        const hostRuns = await this.props.apiService.getMisFetchHostRuns(this.props.tenantId, this.props.schoolCode,this.props.dataServiceType)
        
        let currentHostRun: IMisFetchRun | undefined = undefined;

        if(host?.currentRunId)
        {
            currentHostRun = hostRuns.find(r => r.id === host.currentRunId);
        }

        this.setState({
            host,
            hostRuns,
            currentHostRun
        });
    }


    private deleteHost = async () => {
        await this.props.apiService.deleteMisFetchHost(this.props.tenantId, this.props.schoolCode,this.props.dataServiceType)

        await this.loadHostAndRuns();
    }
    
    private startRun = async () => {
        
        try
        {
            const runOrchestrationId = await this.props.apiService.triggerMisFetchRun(this.props.tenantId, this.props.schoolCode,this.props.dataServiceType);
            const showButton = (
                <MessageBarButton
                    text={"View details"} onClick={() => {
                    window.open(`/cdb-admin/durable-functions/instances/${runOrchestrationId}`,"_blank");
                }}>Yes</MessageBarButton>
            )

            this.props.messageBar.success(`Fetch request successfully sent (${runOrchestrationId})`,showButton);
        }
        catch (e)
        {
            console.log(e);
            this.props.messageBar.error(`Fetch request failed : ${e}`);
        }
    }

    private renderNoConfigMessageBar(): JSX.Element | null {
        if (this.props.dataServiceType !== MisDataServiceTypes.SalamanderHosted || this.state.hostedConfig !== null) {
            return null;
        }

        return (
            <MessageBar messageBarType={MessageBarType.warning}>
                <span>Hosted Salamander must be configured below before data can be fetched</span>
            </MessageBar>
        );
    }
    

    private renderHostTable(): JSX.Element | null {
        
        let hosts: IMisFetchHost[] | undefined | null;
        switch (this.state.host)
        {
            case undefined:
                hosts = undefined;
                break;
            case null:
                hosts = [];
                break
            default:
                hosts = [this.state.host];
                break
        }
        
        
        const deleteButton = (
            <CommandBarButton
                iconProps={{ iconName: "Delete" }}
                disabled={this.state.host === undefined || this.state.host === null}
                text="Stop run (Delete host)"
                onClick={this.deleteHost}
            />
        );
        
        const startButton = (
            <CommandBarButton
                iconProps={{ iconName: "CloudUpload" }}
                disabled={this.props.dataServiceType === MisDataServiceTypes.SalamanderHosted && (this.state.hostedConfig === undefined || this.state.hostedConfig === null)}
                text="Fetch MIS Data"
                onClick={async () => {
                    await this.startRun();
                }}
            />  
        );
        
        return (
            <MisFetchHostTable title={`${this.props.dataServiceType} Status`} hosts={hosts} highlightCurrentRunId={true} emptyMessage={"CDB Cloud is not running"}>
                {this.renderConfigureButton()}
                {this.state.host ? deleteButton : null}
                {this.state.hostedConfig || this.props.dataServiceType !== MisDataServiceTypes.SalamanderHosted ? startButton : null}
            </MisFetchHostTable>
        );
    }
    
    
    renderConfigureButton = (): JSX.Element | null => {
        
        if(this.props.dataServiceType !== MisDataServiceTypes.SalamanderHosted)
        {
            return null;
        }
        
        return (
            <Link to={`/cdb-admin/mis-fetch/${this.props.tenantId}/${this.props.schoolCode}/config`}>
                <CommandBarButton
                    iconProps={{ iconName: "settings" }}
                    text="Configure Hosted Salamander"
                    onClick={() => {
                    }}
                />
            </Link>
        );
    }
    
    render() {

        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Hosted Data" /> 

                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />
                
                <div className={"flex-row flex--justify-content-flex-end flex--align-self-stretch p-right-1rem"}>

                    <Link to={`/cdb-admin/mis-connection-details/${this.props.tenantId}/${this.props.schoolCode}`} className={"flex--justif-self-stretch m-right-05rem m-top-05rem"}>
                        <CommandBarButton
                            className={"flex--align-sel-stretch"}
                            style={{height: "100%"}}
                            iconProps={{ iconName: "settings" }}
                            text="Manage MIS Connections"
                            onClick={() => {
                            }}
                        />
                    </Link>
                              
                    <MisFetchAvailableDataServiceDropdown tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} apiService={this.props.apiService} dataServiceType={this.props.dataServiceType} onSelect={(newDataServiceType: MisDataServiceTypes) => {
                        
                        if(newDataServiceType === MisDataServiceTypes.SalamanderWebService)
                        {
                            this.props.history.push(`/cdb-admin/mailroom/salamander/${this.props.tenantId}/${this.props.schoolCode}/inbox`)
                        }
                        else
                        {
                            this.props.history.replace(`/cdb-admin/mis-fetch/${this.props.tenantId}/${this.props.schoolCode}/${newDataServiceType}`)
                        }
                    }}/>
                </div>
                
                {this.renderNoConfigMessageBar()}

                
                {this.renderHostTable()}
                <MisFetchRunTable
                    title={`${this.props.dataServiceType} runs`}
                    hostRuns={this.state.hostRuns}
                    currentHostRun={this.state.currentHostRun}
                />
           
            </Fragment>
        );
    }
}
